import { useFormEditable } from "../../../hooks/useFormEditable";
import { useFlowNodeMatcher } from "../../../hooks/useFlowNodeMatcher";
import { useModal } from "@/hooks/modals/useModal";
import { usePurchaseRequestDetail } from "../../../hooks/usePurchaseRequest";

export function useRdFormEditable() {
  const { props } = useModal("PURCHASE_REQUEST");
  const { isMainFormDisabled } = useFormEditable();
  const { recordId, mode, viewStatus } = props;
  const isStartedMode = mode === "started";
  const isInReviewMode = mode === "inReview";
  const detail = usePurchaseRequestDetail(recordId);

  const { isMatchPurchaseManagerAuditNodeForRD } = useFlowNodeMatcher(
    detail?.insId,
  );

  // 满足以下条件时，供应商信息表单禁止编辑
  const supplierInfoFormDisabledRules = [
    isStartedMode,
    isInReviewMode && viewStatus === false,
    isMatchPurchaseManagerAuditNodeForRD !== true,
  ];

  const isSupplierInfoFormDisabled = supplierInfoFormDisabledRules.some(
    (rule) => !!rule,
  );

  return {
    isMainFormDisabled,
    isSupplierInfoFormDisabled,
  };
}
